function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelieveryTailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4055"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4054"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "m181.591 128.4-1.112-2.577a2.545 2.545 0 0 0-2.349-1.541h-1.794v-.657a.986.986 0 0 0-.985-.985h-12.53a.652.652 0 0 0-.657.657.669.669 0 0 0 .657.657h12.151v4.85a1.078 1.078 0 0 0 1.086 1.086h4.37v3.057a.226.226 0 0 1-.227.227h-.808a2.431 2.431 0 0 0-2.1-1.213 2.485 2.485 0 0 0-2.1 1.213h-6.745a2.431 2.431 0 0 0-2.1-1.213 2.485 2.485 0 0 0-2.1 1.213h-2.324a.657.657 0 1 0 0 1.314h2a2.428 2.428 0 0 0 4.851 0h6.088a2.428 2.428 0 0 0 4.851 0h.531a1.547 1.547 0 0 0 1.541-1.541v-3.537a2.888 2.888 0 0 0-.2-1.01zm-15.234 7.1a1.112 1.112 0 1 1 1.112-1.112 1.121 1.121 0 0 1-1.111 1.112zm10.939 0a1.112 1.112 0 1 1 1.112-1.112 1.121 1.121 0 0 1-1.108 1.112zm-.985-9.878h1.794a1.184 1.184 0 0 1 1.112.733l.96 2.223h-3.865z",
    transform: "translate(-157.794 -117.64)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M139.538 184.992h4.648a.657.657 0 0 0 0-1.314h-4.648a.652.652 0 0 0-.657.657.669.669 0 0 0 .657.657z",
    transform: "translate(-136.405 -175.925)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M112.1 240.992h4.648a.657.657 0 1 0 0-1.314H112.1a.652.652 0 0 0-.657.657.669.669 0 0 0 .657.657z",
    transform: "translate(-110.203 -229.398)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M89.989 296.338a.652.652 0 0 0-.657-.657h-4.673a.657.657 0 0 0 0 1.314h4.648a.643.643 0 0 0 .682-.657z",
    transform: "translate(-84.002 -282.875)",
    style: {
      fill: "#0a243f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelieveryTailIcon);
export default __webpack_public_path__ + "static/media/DelieveryTailIcon.d8fb501005f8662a4c3271ed06b7b52b.svg";
export { ForwardRef as ReactComponent };